module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "smoothpage"
    }
  }, [_c('menu-transparent', {
    attrs: {
      "transparent": false
    }
  }), _vm._v(" "), _c('my-header', {
    attrs: {
      "transparent": false
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('my-footer')], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "notification"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "back_to_top"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fca6adc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/site/Site.vue
// module id = 380
// module chunks = 0